export default {
  works: (state) => state.works,
  allWorksLoaded: (state) => state.allWorksLoaded,
  work: (state) => state.work,
  noResult: (state) => state.noResult,
};
